import Vue from 'vue';
import Router from 'vue-router';
import OrderViewRoutes from '@/views/Order/router';
import ManageRulesRoutes from '@/views/Manage/Rules/router';
import OverviewRoutes from '@/views/Overview/router';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  mode: (process.env.VUE_APP_ROUTER_MODE || 'history') as any,
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: () => {
        return '/pivot/default';
      }
      // name: 'home',
      // component: () => import(
      //   /* webpackChunkName: "page-home" */
      //   './views/Home.vue'
      // ),
      // meta: {
      //   requiresAuth: true,
      // },
    },
    { // login page
      path: '/login',
      name: 'login',
      meta: {
        requiresAuth: true,
        hideToolbar: true,
        vCenter: true,
      },
      component: () => import(
        /* webpackChunkName: "page-login" */
        './views/Login.vue'
      ),
    },
    {
      path: '/manage/permissions',
      name: 'manage user permissions',
      component: () => import(
        /* webpackChunkName: "page-account_manage_users" */
        './views/Manage/Users'
      ),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/manage/coupons',
      name: 'manage coupons',
      component: () => import(
        /* webpackChunkName: "page-account_manage_coupons" */
        './views/Manage/Coupons.vue'
      ),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/manage/Rules',
      name: 'manage rules',
      component: () => import(
        /* webpackChunkName: "page-account_manage_rules" */
        './views/Manage/Rules/Rules.vue'
      ),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/manage/warehouses',
      name: 'manage warehouses',
      component: () => import(
        /* webpackChunkName: "page-account_manage_warehouses" */
        './views/Manage/Warehouses.vue'
      ),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/manage/packages',
      name: 'manage packages',
      component: () => import(
        /* webpackChunkName: "page-account_manage_packages" */
        './views/Manage/Packages.vue'
      ),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/manage/bundles',
      name: 'manage bundles',
      component: () => import(
        /* webpackChunkName: "page-account_manage_bundles" */
        './views/Manage/Bundles.vue'
      ),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/manage/agents',
      name: 'manage agents',
      component: () => import(
        /* webpackChunkName: "page-account_manage_agents" */
        './views/Manage/Users/SalesAgents.vue'
      ),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/manage/reporting',
      name: 'reporting',
      component: () => import(
        /* webpackChunkName: "page-manage_reporting" */
        './views/Manage/Reporting'
      ),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/manage/reporting/:name',
      name: 'reporting view',
      component: () => import(
        /* webpackChunkName: "page-manage_reporting-view" */
        './views/Manage/Reporting/View.vue'
      ),
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/manage/dynamicmails',
      name: 'dynamicmails',
      component: () => import(
        /* webpackChunkName: "page-manage_dynamicmails" */
        './views/Manage/DynamicMails'
      ),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/manage/licensing',
      name: 'licensing',
      component: () => import(
        /* webpackChunkName: "page-manage_licensing" */
        './views/Manage/Licensing'
      ),
      meta: {
        requiresAuth: true,
      },
    },



    {
      path: '/filter',
      name: 'filter',
      component: () => import(
        /* webpackChunkName: "advanced-filter" */
        '@/components/AdvancedFilter/Operator.vue'
      ),
      props: (route) => {
        return {
          isFirst: true,
          ref: "andOr",
          options: {
            keys: [
              { name: 'Choose Key', id: -99 },
              { name: 'Crash Number', id: 134 },
              { name: 'Daily Startup', id: 256 }], operators: [
                { name: '==', id: '=' },
                { name: '!=', id: '!=' },
                { name: '>', id: '>' },
                { name: '<', id: '<' },
                { name: '>=', id: '>=' }
              ]
          },
        };
      }

    },

    // any pivot view / list
    {
      path: '/pivot/:ViewName?', // :BaseViewName
      name: 'list data on a pivot view',
      component: () => import(/* webpackChunkName: "page-pivot-view" */ '@/views/Pivot/Pivot.vue'),
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        requiresAuth: true
      }
    },

    // any calendar view
    {
      path: '/calendar', // :BaseViewName
      name: 'list data on a calendar view',
      component: () => import(/* webpackChunkName: "page-calendar-view" */ '@/views/Calendar/Calendar.vue'),
      props: (route) => Object.assign({}, route.params, route.query),
      meta: {
        requiresAuth: true
      }
    },

    // order view routes - creation of order / update of order
    ...OrderViewRoutes,
    ...ManageRulesRoutes,
    ...OverviewRoutes,

  ],
});


